import { render } from "./StatsWDL.vue?vue&type=template&id=23153af8&scoped=true"
import script from "./StatsWDL.vue?vue&type=script&lang=js"
export * from "./StatsWDL.vue?vue&type=script&lang=js"

import "./StatsWDL.vue?vue&type=style&index=0&id=23153af8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23153af8"]])

export default __exports__